<template>
  <base-section
    id="affiliates"
    space="50">
    <v-container>
      <base-section-heading title="Kantor Pemasaran dan Mitra Layanan" />
      <v-card>
        <v-card-title>
          <div>
            <span
              class="tab-toggle mr-4"
              :class="{'tab-toggle--active': activeTab === 'marketing'}"
              @click="activeTab = 'marketing'"
            >
              Kantor Pemasaran
            </span>
            <span
              class="tab-toggle"
              :class="{'tab-toggle--active': activeTab === 'mitra'}"
              @click="activeTab = 'mitra'"
            >
              Mitra
            </span>
          </div>
          <v-spacer />
          <v-text-field
            v-model="searchText"
            append-icon="mdi-magnify"
            :label="activeTab === 'marketing' ? 'Cari Kantor Pemasaran' : 'Cari Mitra'"
            single-line
            hide-details
            class="ma-0"
            style="max-width: 320px"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="activeItems"
          :search="searchText"
          item-key="branch_name"
          class="elevation-1"
        >
          <template v-slot:item.branch_address="{ item }">
            {{item.branch_address}} <a :href="`https://maps.google.com/maps?q=${item.branch_latitude},${item.branch_longitude}`" target="blank">Lokasi</a>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionNetwork',
    data: () => ({
      activeTab: 'marketing',
      searchMarketing: '',
      searchMitra: '',
      branch: [],
      headers: [
        {
          text: 'Kantor',
          align: 'start',
          value: 'branch_name',
          class: "primary white--text body-1",
          width: '20%'
        },
        { text: 'Alamat', value: 'branch_address',class: "primary white--text body-1" },
        { text: 'Telepon', value: 'branch_phone_1',class: "primary white--text body-1", width: '15%' },
        { text: 'Email', value: 'branch_email',class: "primary white--text body-1", width: '15%' },
        { text: 'PIC', value: 'branch_pic',class: "primary white--text body-1", width: '10%' },
      ],
    }),
    computed: {
      marketingBranches () {
        return this.branch.filter(branch => branch && branch.branch_flag !== 'BRM')
      },
      mitraBranches () {
        return this.branch.filter(branch => branch && branch.branch_flag === 'BRM')
      },
      activeItems () {
        return this.activeTab === 'marketing' ? this.marketingBranches : this.mitraBranches
      },
      searchText: {
        get () {
          return this.activeTab === 'marketing' ? this.searchMarketing : this.searchMitra
        },
        set (val) {
          if (this.activeTab === 'marketing') {
            this.searchMarketing = val
          } else {
            this.searchMitra = val
          }
        }
      }
    },
    created () {
    	this.Branch()
    },
    methods: {
      	Branch () {
          let formdata = {
                branch_actived: 'Y',
                order_by: 'branch_id',
                order_type: 'ASC',
          }
          let param      = this.$functions.ParamPOST(formdata)
          this.$axios.post(this.$functions.UrlPOST('apiWebBranchList'),param,{
          headers: {
              'Content-Type': 'text/plain; charset=ISO-8859-1'
          }
          })
          .then(response => {
              this.branch = Array.isArray(response.data) ? response.data : []
          })
          .catch(e => {
              alert(e)
          })
        },
    }
  }
</script>
<style>
tbody tr:nth-of-type(odd) {
   background-color: rgba(0, 0, 0, .05);
 }
.tab-toggle {
  cursor: pointer;
  display: inline-block;
  padding: 8px 0;
  color: #1a1a1a;
  font-weight: 600;
  transition: color 0.2s ease, border-color 0.2s ease;
  border-bottom: 3px solid transparent;
}
.tab-toggle--active {
  color: #00bcd4;
  border-color: #00bcd4;
}
</style>
